module.exports = __webpack_public_path__ + "img/RSV_btn.d5477d8a.webp";